<template>
  <BjDialog :visible="dialogVisible" width="800px" center @close="dialogVisible = false">
    <el-form ref="form" :model="form" label-width="140px">
      <el-form-item :label="$t('ChannelManagement.cron.CardType')">
        <el-radio-group v-model="form.orderNeedDelay">
          <el-radio :label="1">{{ $t('ChannelManagement.cron.cardOrder') }}</el-radio>
          <el-radio :label="2">{{ $t('ChannelManagement.cron.cardSheet') }}</el-radio>
          <el-radio :label="3">{{ $t('ChannelManagement.cron.ForeverStuck') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.orderNeedDelay === 1" :label="$t('ChannelManagement.cron.Hour')">
        <el-select v-model="hourText" style="width:290px">
          <el-option v-for="item in 25" :key="item - 1" :value="item - 1">{{ item - 1 }}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.orderNeedDelay === 2" label="" style="padding-right:100px">
        <vcrontab ref="vcrontabRef" :expression="form.delayRules">
          <el-checkbox v-model="isSkipWeekend">{{ $t('ChannelManagement.cron.WhetherSkipWeekend') }}</el-checkbox>
        </vcrontab>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </span>
  </BjDialog>
</template>
<script>
import vcrontab from './components/Crontab.vue';
import { channelApi } from '@/api';

const DEFAULT_ORDER_CONFIG = {
  orderNeedDelay: 1,
  delayRules: 1
};
const SKIP_WEEKEND_RULE = '* * * ? * 1,7';

function getDefaultForm() {
  return {
    id: null,
    ...DEFAULT_ORDER_CONFIG
  };
}

function hasValue(value) {
  return value !== null && value !== undefined && value !== '';
}

export default {
  components: { vcrontab },
  data() {
    return {
      dialogVisible: false,
      form: getDefaultForm(),
      hourText: 1,
      isSkipWeekend: false
    };
  },
  methods: {
    show(id) {
      this.resetForm(id);
      this.dialogVisible = true;
      if (id) {
        this._getOnlineShopDetails();
      }
    },
    resetForm(id) {
      this.form = {
        ...getDefaultForm(),
        id
      };
      this.hourText = DEFAULT_ORDER_CONFIG.delayRules;
      this.isSkipWeekend = false;
    },
    _getOnlineShopDetails() {
      channelApi.getOnlineShopDetails({ id: this.form.id }).then(res => {
        const detail = { ...(res || {}) };
        const hasOrderNeedDelay = hasValue(detail.orderNeedDelay);
        const hasDelayRules = hasValue(detail.delayRules);
        const isCronDelayRule = hasDelayRules && isNaN(detail.delayRules);

        detail.orderNeedDelay = hasOrderNeedDelay ? Number(detail.orderNeedDelay) : (isCronDelayRule ? 2 : DEFAULT_ORDER_CONFIG.orderNeedDelay);

        if (isCronDelayRule) {
          const rules = String(detail.delayRules).split(';');
          detail.delayRules = rules[0];
          this.isSkipWeekend = rules.includes(SKIP_WEEKEND_RULE);
        } else {
          this.isSkipWeekend = false;
        }

        detail.delayRules = hasDelayRules ? detail.delayRules : DEFAULT_ORDER_CONFIG.delayRules;
        if (detail.orderNeedDelay === 1) {
          this.hourText = Number(detail.delayRules);
        }
        this.form = { ...this.form, ...detail };
      });
    },
    confirm() {
      if (this.form.orderNeedDelay === 1) {
        this.form.delayRules = this.hourText;
      } else if (this.form.orderNeedDelay === 2) {
        if (this.isSkipWeekend) {
          this.form.delayRules = this.$refs.vcrontabRef.contabValueString + `;${SKIP_WEEKEND_RULE}`;
        } else {
          this.form.delayRules = this.$refs.vcrontabRef.contabValueString;
        }
      } else if (this.form.orderNeedDelay === 3) {
        this.form.delayRules = null;
      }
      channelApi.saveOnlineShop(this.form).then((res) => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.dialogVisible = false;
        }
      });
    }
  },
};
</script>
